import http from './http'

export function unwrap (response) {
  return response && response.data ? response.data.data : null
}

export function errorText (error) {
  return error && error.response && error.response.data
    ? (error.response.data.message || error.response.data.error || '接口处理失败')
    : (error && error.message) || '网络连接失败'
}

export function errorTraceId (error) {
  const value = error && error.response && error.response.headers && error.response.headers['x-request-id']
  return typeof value === 'string' && /^[a-f0-9-]{36}$/.test(value) ? value : ''
}

export const api = {
  list (url, params) { return http.get(url, { params }).then(unwrap) },
  get (url) { return http.get(url).then(unwrap) },
  post (url, body) { return http.post(url, body).then(unwrap) },
  put (url, body) { return http.put(url, body).then(unwrap) },
  remove (url) { return http.delete(url).then(unwrap) }
}

export default api
